// extracted by mini-css-extract-plugin
export default {"overlay":"NotifyModal_overlay__MrXJg","notifyModal":"NotifyModal_notifyModal__qktky","closeButton":"NotifyModal_closeButton__4cAz-"};